export default __webpack_public_path__ + "static/media/room1_img.3474618d.png";